import * as React from 'react';
import { Dialog, DialogType, DialogFooter } from '@fluentui/react';
import { PrimaryButton, DefaultButton } from '@fluentui/react';
import { getId } from '@fluentui/react';
import { hiddenContentStyle, mergeStyles } from '@fluentui/react';
import { ContextualMenu } from '@fluentui/react';
import {TextField} from '@fluentui/react';


const screenReaderOnly = mergeStyles(hiddenContentStyle);

export interface IDialogBasicExampleState {
    hideDialog: boolean;
    isDraggable: boolean;
}

export class ApproverDialog extends React.Component<{}, IDialogBasicExampleState> {
    state: IDialogBasicExampleState = {
        hideDialog: true,
        isDraggable: false,
        comment : null,
        warning : false,
    };
    // Use getId() to ensure that the IDs are unique on the page.
    // (It's also okay to use plain strings without getId() and manually ensure uniqueness.)
    _labelId: string = getId('dialogLabel');
    _subTextId: string = getId('subTextLabel');
    _dragOptions = {
        moveMenuItemText: 'Move',
        closeMenuItemText: 'Close',
        menu: ContextualMenu
    };


    onWriteEvent (e,v)
    {
      if(v.length > 0)
      {
          this.setState({warning: false})
      }
      this.setState({comment:v});
    }

    render() {
        const { hideDialog, isDraggable } = this.state;
        return (
            <div>
                <PrimaryButton styles={this.props.btnStyle} secondaryText="Opens the Sample Dialog" onClick={this._showDialog} text={this.props.buttonName} />
                <label id={this._labelId} className={screenReaderOnly}>
                    My sample Label
                </label>
                <label id={this._subTextId} className={screenReaderOnly}>
                    My Sample description
                </label>

                <Dialog
                    hidden={hideDialog}
                    onDismiss={this._closeDialog}
                    dialogContentProps={{
                        type: DialogType.normal,
                        title: this.props.title,
                        subText: this.props.text
                    }}
                    modalProps={{
                        titleAriaId: this._labelId,
                        subtitleAriaId: this._subTextId,
                        isBlocking: false,
                        styles: { main: { maxWidth: 450 } },
                        dragOptions: isDraggable ? this._dragOptions : undefined
                    }}
                >
                    <div>
                       <div style={purposeStyles}>
                           <div style={titleStyles}>Purpose:</div>
                           {this.props.reason} </div>
                       </div>

                    <DialogFooter>
                        <PrimaryButton onClick={this._confirm} text="Approve" />
                        <PrimaryButton style={{backgroundColor:'red'}} onClick={this._reject} text="Reject" />
                        <DefaultButton onClick={this._closeDialog} text="Cancel" />
                    </DialogFooter>

                    <TextField
                        label="Required if reject*"
                        name="Commesnt"
                        onChange={this.onWriteEvent.bind(this)}
                        validationResult={this.state.commentValidation}
                        multiline
                        rows={3}
                        errorMessage={this.state.warning? "Comment required" : null}
                    />
                </Dialog>
            </div>
        );
    }

    _confirm = () : void =>
    {
        this.props.onApprove(this.state.comment);
        this._closeDialog();
    }

    _reject = (): void =>
    {

        if(this.state.comment == null || this.state.comment.length === 0)
        {
            this.setState({warning:true})
            return;
        }

        this.props.onReject(this.state.comment);
    }
    _showDialog = (): void => {
        this.setState({ hideDialog: false });
    };

    _closeDialog = (): void => {
        this.setState({ hideDialog: true });
    };

    _toggleDraggable = (): void => {
        this.setState({ isDraggable: !this.state.isDraggable });
    };
}

const titleStyles = {
    fontWeight: 'bold',
    marginBottom:'3px',
}

const purposeStyles = {
    marginBottom:'8px',
    minHeight: '20px',
    overflowWrap: 'break-word'
}



// WEBPACK FOOTER //
// ./src/components/ManageCenter/ApproverDialog.js